import { equals, find,pathOr,values } from 'ramda';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'src/store/ApplicationState';

export const getLoanAppForLendsmart = (itemsById: any[], id: string) => {
  const loanApp = find((loanApp: any) => {
      return equals(pathOr('',['id'],loanApp), id);
    },values(itemsById));
  return loanApp;
};



export const useLoanApp = () => {
  const loanApp = useSelector(
    (state: ApplicationState) => pathOr({},['__resources','loanApp','data'],state)
  );
  const loanId = pathOr('', ['id'], loanApp);
  const loanType = pathOr('', ['type_of_loan'], loanApp);

  return {
    loanId,
    loanType
  };
};
export default useLoanApp;
